import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box, Card, Link, Typography, Stack, Grid, Container, Tab, Tabs } from '@mui/material';

const useStyles = styled((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(4),
            width: '25ch',
        },
    },
}));

const UserProfileForm = ({ user }) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const userObj = user === null ? { 'first_name': '', 'last_name': '', 'email': '', 'subscriptionStatus': '' } : user

    return (



        <form className={classes.root} noValidate autoComplete="off">
            <Grid container spacing={4} >
                <Grid item xs={12} sm={12} md={12}>
                    <TextField id="first-name" label="Name" value={userObj.first_name} margin="normal"/>
                    <TextField id="last-name" label="Surname" value={userObj.last_name} margin="normal" />
                </Grid>
                <Grid item xs={6}  >
                    <TextField id="email" label="Email" disabled value={userObj.email} fullWidth />
                </Grid>
                <Grid item xs={24}>
                    {userObj.user_id ? <TextField id="telegram-id" label="Telegram bot ID" disabled value={userObj.user_id} /> : null}
                </Grid>
            </Grid>
        </form >


    );
}
export default UserProfileForm;